import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { BaryTitleComponent } from '../bary-title/bary-title.component';
import { TranslateDirective } from '../../../../directives/translate.directive';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { TranslateModule } from '@ngx-translate/core';
import { NgForOf, NgIf } from '@angular/common';

@Component({
  selector: 'jhi-bary-input-multi-select',
  templateUrl: './bary-input-multi-select.component.html',
  standalone: true,
  styleUrls: ['./bary-input-multi-select.component.scss'],
  imports: [ReactiveFormsModule, BaryTitleComponent, TranslateDirective, MDBBootstrapModulesPro, TranslateModule, NgIf, NgForOf],
})
export class BaryInputMultiSelectComponent {
  @Input() id = '';
  @Input() placeholder: string | undefined;
  @Input() label: string | undefined;
  @Input() name: string | undefined;
  @Input() disabled = false;
  @Input() control: FormControl = new FormControl([]);
  @Input() tooltip?: string;
  @Input() options!: { label: string; value: any }[];
  @Input() title?: string;

  @Output() onChangeEvent = new EventEmitter<string[]>();
}
